<template>
  <section>
    <section class="">
      <CardTipoAgentes
        v-if="!formSolicitacao.tipoSolicitacao"
        :items="documentos"
        :value="formSolicitacao.tipoSolicitacao"
        @input="onTipoSolicitacaoSelecionado"
      />
    </section>
    <v-container
      v-if="formSolicitacao.tipoSolicitacao"
      class="pa-0 mt-5"
      style="max-width: 950px; margin-top: 0; align-items: flex-start"
    >
      <AppLoader :loading="loadingSolicitacao" message="Enviando solicitação..." />
      <template>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step v-for="h in steps" :key="h.step" :step="h.step" :complete="step > h">
              {{ h.title }}
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content v-for="s in steps" :key="s.step" :step="s.step">
              <StepUmDadosSolicitante
                v-show="s.component == 'StepUmDadosSolicitante' && !finishMessage"
                :documentos="documentos"
                :resetting="resetting"
              />
              <StepDoisDocumentacao
                v-if="s.component == 'StepDoisDocumentacao' && !finishMessage"
              />
              <Finalizacao
                v-if="finishMessage"
                :response="solicitacaoCriada"
                @limparForm="handleLimparForm"
                @voltarStep1="handleVoltarStep1"
              />

              <section class="d-flex justify-end mt-5">
                <!-- <v-btn v-if="s.step === 1" color="primary" @click -->
                <v-btn
                  v-if="s.component == 'StepUmDadosSolicitante'"
                  :disabled="!camposPreenchidos"
                  color="primary"
                  @click="nextStep()"
                >
                  Avançar
                </v-btn>
                <section
                  v-if="s.component == 'StepDoisDocumentacao' && !finishMessage"
                  class="d-flex justify-space-between"
                  style="width: 100%"
                >
                  <v-btn color="primary" @click="step--"> Voltar </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!documentosObrigatoriosAdicionados"
                    @click="createSolicitacao()"
                  >
                    Concluir
                  </v-btn>
                </section>
              </section>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </template>
    </v-container>
  </section>
</template>

<script lang="js">

import SolicitacaoService from '@/services/spgc/solicitacao.service';
import StepUmDadosSolicitante from './components/StepUmDadosSolicitante.vue';
import StepDoisDocumentacao from './components/StepDoisDocumentacao.vue';
import Finalizacao from './components/StepFinalizacao.vue';
import AppLoader from '@/components/AppLoader.vue';
import { mapActions, mapState } from 'vuex';
import solicitacao from '@/store/modules/solicitacao';
import moment from 'moment';
import CardTipoAgentes from './components/CardTipoAgentes.vue';

export default {
  name: "SolicitarAutorizacao",
  components: {
    StepUmDadosSolicitante,
    StepDoisDocumentacao,
    Finalizacao,
    AppLoader,
    CardTipoAgentes
  },
  data: () => ({
    resetting: false,
    documentos: [],
    step: 1,
    steps: [
      { title: "Dados do Solicitante", step: 1, component: 'StepUmDadosSolicitante' },
      { title: "Documentação", step: 2, component: 'StepDoisDocumentacao' },
      // { title: "Finalização", step: 3, component: 'Finalizacao' },
    ],
    solicitacaoCriada: {numeroProtocolo: '', dataCriacao: ''},
    finishMessage: false,
    loadingSolicitacao: false,
  }),
  computed: {
      ...mapState('spgc', [ 'recaptcha','formSolicitacao', 'documentacaoPorTipoSolicitacao','possuiSolicitacaoEmAndamento','documentosPorRegra']),
    camposPreenchidos() {
      const f = this.formSolicitacao;
      // Regras de validação
      const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return (
        f.tipoSolicitacao &&
        f.cnpj &&
        f.nomeEmpresa &&
        f.email && emailPattern.test(f.email) &&
        f.telefone &&
        f.endereco &&
        f.prepostoEmpresa &&
        this.possuiSolicitacaoEmAndamento == false
      );
    },
    documentosObrigatoriosAdicionados() {
      const recaptchaPreenchido = !!this.recaptcha && this.recaptcha !== '';
      return this.contarDocumentosNecessarios() == this.formSolicitacao.arquivos.length && recaptchaPreenchido;
    }



},
  mounted() {
    this.getRegras();
  },
  destroyed() {
    this.handleLimparForm();
  },
  methods: {
    nextStep() {
      if (this.step !== this.steps.length) {
        this.step++;
      }
    },

    getRegras() {
      SolicitacaoService.getRegrasValidacao()
        .subscribe((response) => {
          this.documentos = response.result;
          this.setDocumentosPorRegra(response.result);

        }, (error) => {
          console.error('Erro ao buscar serviços:', error);
        })

    },
    createSolicitacao() {
      this.loadingSolicitacao = true;
      SolicitacaoService.createSolicitacao(this.formSolicitacao)
        .subscribe(
          (response) => {
            const { result } = response;
            this.solicitacaoCriada = {
              numeroProtocolo: result.id,
              dataCriacao: moment(result.createdDate).format('DD/MM/YYYY HH:mm'),
              token: result.token
            };
            this.finishMessage = true;
            this.loadingSolicitacao = false;
          },
          (error) => {
            console.error('Erro ao criar solicitação:', error);
            this.loadingSolicitacao = false;
          }
        );
    },

      contarDocumentosNecessarios() {
        let total = 0;
        const regras = this.documentacaoPorTipoSolicitacao[0]?.regras || [];
        regras.forEach(regra => {
          if (regra.requer === "TODOS") {
            total += regra.documentos.length;
          } else if (regra.requer === "PELO_MENOS_UM") {
            total += 1;
          }
        });
        return total;
    },
    handleLimparForm() {
      this.resetting = true;
      this.resetForm();

    },
    handleVoltarStep1() {
      this.step = 1;
      this.finishMessage = false;
    },
    onTipoSolicitacaoSelecionado(tipo) {
      this.formSolicitacao.tipoSolicitacao = tipo;
          this.setDocumentosPorTipoSolicitacao(
        this.documentosPorRegra.filter(doc => doc.tipoSolicitacao === tipo)
      );
      // this.emitirDocumentoSelecionado();
    },

      ...mapActions('spgc', ['setDocumentosPorRegra','resetForm', 'setDocumentosPorTipoSolicitacao']),


    },
};
</script>
